import { render, staticRenderFns } from "./SettingsMaterialItemForm.vue?vue&type=template&id=6b710640&scoped=true&"
import script from "./SettingsMaterialItemForm.vue?vue&type=script&lang=ts&"
export * from "./SettingsMaterialItemForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b710640",
  null
  
)

export default component.exports